export default "__VITE_ASSET__DKQzrFmj__"